import * as Models from "../ts/rlAdmin.models";


export class EntityCharDataService {

    private _checkForRecCharData: ((entityID: string, charID: number) => number)[] = [];
    private _createdRecCharData: ((entityID: string, charID: number, recCharID: number) => boolean)[] = [];

    private _getAllDateMathCharDatas: (() => Models.ICharDataValue[])[] = [];

    constructor() {

    }

    OnCheckForRecCharData(action: (entityID: string, charID: number) => number) {
        this._checkForRecCharData.push(action);
    }

    OffCheckForRecCharData(action: (entityID: string, charID: number) => number) {
        _.remove(this._checkForRecCharData, action);
    }

    CheckForRecCharData(entityID: string, charID: number) {
        var output: number = null;

        for (var i = 0; i < this._checkForRecCharData.length; i++) {
            output = this._checkForRecCharData[i](entityID, charID);
            if (output) {
                return output;
            }
        }
        return output;
    }

    OnCreatedRecCharData(action: (entityID: string, charID: number, recCharID: number) => boolean) {
        this._createdRecCharData.push(action);
    }

    OffCreatedRecCharData(action: (entityID: string, charID: number, recCharID: number) => boolean) {
        _.remove(this._createdRecCharData, action);
    }

    CreatedRecCharData(entityID: string, charID: number, recCharID: number) {
        for (var i = 0; i < this._createdRecCharData.length; i++) {
            if (this._createdRecCharData[i](entityID, charID, recCharID)) {
                break;
            }
        }
    }

    OnGetAllDateMathCharDatas(action: () => Models.ICharDataValue[]) {
        this._getAllDateMathCharDatas.push(action);
    }

    OffGetAllDateMathCharDatas(action: () => Models.ICharDataValue[]) {
        _.remove(this._getAllDateMathCharDatas, action);
    }

    GetAllDateMathCharDatas() {
        var output = _.flatten(this._getAllDateMathCharDatas.map(fn => fn()));
        //console.log(`checking them all ${output.length} of them`);
        return output;
    }
}
